import React from "react";

// Line icons for the ops-hub modules (one stroke style, inherits currentColor).
const PATHS = {
  reorder: <><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z" /><path d="m3 7.5 9 4.5 9-4.5M12 12v9" /></>,
  ars: <><rect x="5" y="3.5" width="14" height="17" rx="2" /><path d="M9 3.5h6v3H9zM8.5 11h7M8.5 14.5h7M8.5 18h4" /></>,
  wh_refill: <><path d="M3 9.5 9 6l6 3.5V20H3z" /><path d="M6.5 20v-5h5v5" /><path d="M15 13h3.5l2.5 3v4h-6" /><circle cx="17" cy="20" r="1.3" /></>,
  // 2026-10-08 UI pass: Stock Reco had no icon and fell back to the Reorder box.
  stock_reco: <><path d="M12 3v18M7 21h10M5 7h14" /><path d="m5 7-3 7a3 3 0 0 0 6 0zM19 7l-3 7a3 3 0 0 0 6 0z" /></>,
  channel_profit: <><path d="M12 3v18M5 21h14" /><path d="M5 7h14" /><path d="m5 7-3 7a3 3 0 0 0 6 0L5 7zM19 7l-3 7a3 3 0 0 0 6 0l-3-7z" /></>, // 2026-10-27 Channel Profitability (balance)
  ecom_otb: <><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /><path d="m3 7 4-3 4 2 5-4" /></>, // 2026-10-24 Ecom OTB
  discount_verify: <><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" /><circle cx="7.5" cy="7.5" r="1.5" /></>,
};

export default function ModuleIcon({ id, size = 20, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0, ...style }}>
      {PATHS[id] || PATHS.reorder}
    </svg>
  );
}

// Brand mark (accent tile + circular arrow) - the single logo used by the header and every sign-in screen.
export function BrandMark({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" style={{ flexShrink: 0, display: "block" }}>
      <rect width="32" height="32" rx="7" fill="var(--accent)" />
      <path d="M16 7.5a8.5 8.5 0 1 1-8.1 5.9" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M5.2 10.6 8 14.4l3.9-2.6" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
